import { useEffect, useState } from 'react';
import { ory } from '@/auth';
import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { z } from 'zod';
import { useAuth } from '@/stores/auth';

const loginSearchSchema = z.object({
  returnTo: z.string().optional(),
});

export const Route = createFileRoute('/$tenantId/logout')({
  component: Logout,
  validateSearch: zodSearchValidator(loginSearchSchema),
});

function Logout() {
  const { returnTo } = Route.useSearch();
  const [error, setError] = useState<string | null>(null);
  const { logout } = useAuth();

  useEffect(() => {
    logout();
    ory
      .createBrowserLogoutFlow({
        returnTo: returnTo || `${window.location.origin}/`,
      })
      .then(({ data }) => {
        window.location.replace(data.logout_url);
      })
      .catch((err) => {
        console.error(err);
        setError(err.message);
      });
  }, [returnTo, logout]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  return <div>Loading...</div>;
}
